export const isValidSSN = (ssn: string): boolean => {
  const regex = /^(?!000|666)[0-8]\d{2}-(?!00)\d{2}-(?!0000)\d{4}$/;
  return regex.test(ssn);
};
